import './Terminal.css';

import { PureComponent } from 'react';

import { Tooltip } from '@ipfabric/ui-components/Tooltip/Tooltip';
import { Button } from 'components/Button/Button';
import LTEBox from 'containers/LTEBox';
import { List } from 'immutable';
import PropTypes from 'prop-types';
import handleEvent from 'utils/handleEvent';
import PinToBottom from './PinToBottom';

let rowsDebounce = null;

export default class Terminal extends PureComponent {
  static propTypes = {
    btnClearTitle: PropTypes.string,
    defaultCountRows: PropTypes.number.isRequired,
    divClass: PropTypes.string.isRequired,
    downloadLogKey: PropTypes.string.isRequired,
    heightPx: PropTypes.number.isRequired,
    label: PropTypes.string.isRequired,
    messagesList: PropTypes.instanceOf(List),
    msg: PropTypes.object.isRequired,
    onClear: PropTypes.func.isRequired,
    onDownloadLog: PropTypes.func.isRequired,
    downloading: PropTypes.bool,
  };

  static defaultProps = {
    btnClearTitle: 'Clear',
  };

  constructor(props) {
    super(props);
    this.state = {
      countRows: props.defaultCountRows,
      inputCountRows: props.defaultCountRows,
      collapsed: false,
    };
  }

  getData = () => {
    const { messagesList } = this.props;
    const count =
      Number(this.state.countRows) > 0
        ? Number(this.state.countRows)
        : this.props.defaultCountRows;
    return messagesList.size >= count
      ? messagesList.slice(count * -1)
      : messagesList;
  };

  getMessages() {
    const data = this.getData();
    const highSeverityRgx = /(warn|error):/;
    return data.map((msg, i) => {
      return (
        <li
          className={`level-${msg.match(highSeverityRgx)?.[1]}`}
          key={`${i}-${msg}`}
        >
          {msg}
        </li>
      );
    });
  }

  handleClearBtnClick = handleEvent(() => {
    document.activeElement.blur();
    const { onClear } = this.props;
    onClear();
  });

  handleChangeRows = handleEvent(({ target: { value } }) => {
    this.setState({ inputCountRows: value });
    if (rowsDebounce) {
      clearTimeout(rowsDebounce);
    }
    rowsDebounce = setTimeout(() => this.setState({ countRows: value }), 600);
  });

  handleDownloadLogBtnClick = handleEvent((e) => {
    e.preventDefault();
    document.activeElement.blur();
    const { downloadLogKey, onDownloadLog } = this.props;
    onDownloadLog({ downloadLogKey });
  });

  handleToggleCollapse = handleEvent((e) => {
    e.preventDefault();
    document.activeElement.blur();
    this.setState({ collapsed: !this.state.collapsed });
  });

  render() {
    const { label, btnClearTitle, heightPx, divClass, msg, downloading } =
      this.props;
    const { collapsed } = this.state;
    const data = this.getData();
    const cls = `${divClass}`;
    return (
      <div className={cls}>
        <LTEBox
          bodyComponent={
            <PinToBottom data={data}>
              <ul
                className='terminal list-unstyled winston'
                style={{ height: heightPx }}
              >
                {this.getMessages()}
              </ul>
            </PinToBottom>
          }
          className={`box box-service ${collapsed ? 'collapsed-box' : ''}`}
          headerComponent={
            <div>
              <h3 className='box-title'>{label}</h3>
              <div className='box-tools pull-right'>
                <input
                  className='rows-input'
                  onChange={this.handleChangeRows}
                  placeholder={msg.countOfRows}
                  title={msg.countOfRows}
                  type='text'
                  value={this.state.inputCountRows}
                />
                <Tooltip content={btnClearTitle}>
                  <Button
                    variant='tertiary'
                    size='xxs'
                    className='mr-1'
                    onClick={this.handleClearBtnClick}
                    type='button'
                    icon='fa-trash-can'
                  />
                </Tooltip>
                <Tooltip content={msg.downloadLog}>
                  <Button
                    variant='tertiary'
                    size='xxs'
                    className='mr-1'
                    onClick={this.handleDownloadLogBtnClick}
                    type='button'
                    icon='fa-download'
                    loading={downloading}
                  />
                </Tooltip>
                <Tooltip content={msg.collapse}>
                  <Button
                    variant='tertiary'
                    size='xxs'
                    onClick={this.handleToggleCollapse}
                    type='button'
                    icon={collapsed ? 'fa-plus' : 'fa-minus'}
                  />
                </Tooltip>
              </div>
            </div>
          }
          title=''
        />
      </div>
    );
  }
}
